export default __webpack_public_path__ + "static/penmate-logo-text-065a726ea953234321c18d2a7ff04a76.png";